import "./ToastComp.css";
import { IconComp as c } from "./IconComp.js";
import { defineComponent as l, resolveComponent as a, openBlock as o, createBlock as i, Transition as m, withCtx as p, createElementBlock as d, normalizeClass as _, createCommentVNode as n, renderSlot as u, createElementVNode as h, withModifiers as f, createVNode as T } from "vue";
import { _ as C } from "./_plugin-vue_export-helper.dad06003.js";
const v = l({
  name: "toast-comp",
  components: { IconComp: c },
  props: {
    show: {
      type: Boolean,
      required: !0
    },
    color: {
      type: String,
      default: "red"
    },
    icon: String,
    timer: Number
  },
  data() {
    return {
      closeTimer: 0
    };
  },
  methods: {
    close() {
      this.$emit("close"), clearTimeout(this.closeTimer);
    }
  },
  watch: {
    show() {
      this.show && this.timer && (this.closeTimer = setTimeout(this.close, this.timer));
    }
  },
  created() {
    this.timer && (this.closeTimer = setTimeout(this.close, this.timer));
  }
});
function y(e, t, w, k, $, b) {
  const s = a("icon-comp");
  return o(), i(m, { name: "slide" }, {
    default: p(() => [
      e.show ? (o(), d("div", {
        key: 0,
        class: _(["toast", e.color])
      }, [
        e.icon ? (o(), i(s, {
          key: 0,
          class: "icon-toast",
          icon: e.icon
        }, null, 8, ["icon"])) : n("", !0),
        u(e.$slots, "default", {}, void 0, !0),
        h("button", {
          class: "close",
          onClick: t[0] || (t[0] = f((...r) => e.close && e.close(...r), ["prevent"]))
        }, [
          T(s, {
            class: "icon-close",
            icon: "close_small",
            label: "Close Toast"
          })
        ])
      ], 2)) : n("", !0)
    ]),
    _: 3
  });
}
const V = /* @__PURE__ */ C(v, [["render", y], ["__scopeId", "data-v-ad3ab113"]]);
export {
  V as ToastComp
};
//# sourceMappingURL=ToastComp.js.map
